import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-spatial-modelling',
  templateUrl: './spatial-modelling.component.html',
  styleUrls: ['./spatial-modelling.component.scss']
})
export class SpatialModellingComponent implements OnInit {

  information: CardContent = {
    title: 'Spatial Demography',
    sections: [
      `Since the transmission of directly transmitted diseases is
      driven by the high contact rates among children, models on
      the basis of spatial demography can improve policy making
      with regionally adequate recommendations. For example, the
      map of Switzerland to the right shows a low fraction of
      children in urban areas and the south (red, 16%) and large
      fractions of children in rural areas (green, up to 32%).
      `
      ,
    ]
  };

  exposition: CardContent = {
    title: 'Spatial Modelling',
    subtitle: 'Spatial distribution of children in Switzerland',
    image_source: 'assets/images/SwissChildren.png',
  };

  constructor() { }

  ngOnInit(): void {
  }

}
